import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const containerStickerVariants = cva('', {
  variants: {
    variant: {
      greyTimer: css.greyTimer,
      greyTimerGold: cn(css.greyTimerGold, css.greyTimer),
      greyInactive: css.greyInactive,
    },
  },
});

interface ContainerStickerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof containerStickerVariants> {
  text: string;
}

const ContainerSticker = forwardRef<HTMLDivElement, ContainerStickerProps>(
  ({ variant, text, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(containerStickerVariants({ variant }), props.className)}
      >
        <span className={css[`${variant}Text`]}>{text}</span>
      </div>
    );
  },
);

export { ContainerSticker };
